import React, { useEffect, useState } from "react";
import mapValues from "lodash/mapValues";
import styled from "styled-components";
import { Button } from "components/bootstrap";
import { Icon } from "components/common";
import { ConfigurationFormField } from "components/configurationforms";
const StyledButton = styled(Button)`
  margin-bottom: 20px;
`;
const StyledIcon = styled(Icon)`
  margin-right: 0.5em;
`;
const InputConfigurationForm = ({
  type,
  handleConfigurationChange,
  inputDescription,
  setDefaultValues,
  values = {},
  configurationFieldStates
}) => {
  const [displayOptionalFields, setDisplayOptionalFields] = useState(false);
  const configurationFields = inputDescription.requested_configuration;
  useEffect(() => {
    if (!values || Object.keys(values).length === 0) {
      const defaultValues = mapValues(configurationFields, (configuration) => configuration.default_value);
      setDefaultValues(defaultValues);
    }
  }, [type, configurationFields, values, setDefaultValues]);
  const mandatoryFields = Object.keys(configurationFields).filter((field) => !configurationFields[field].is_optional);
  const optionalFields = Object.keys(configurationFields).filter((field) => configurationFields[field].is_optional);
  const renderField = (field) => /* @__PURE__ */ React.createElement(
    ConfigurationFormField,
    {
      key: field,
      typeName: type,
      configField: configurationFields[field],
      configKey: field,
      configValue: values[field] || "",
      autoFocus: false,
      dirty: configurationFieldStates[field] && configurationFieldStates[field].dirty,
      onChange: handleConfigurationChange
    }
  );
  return /* @__PURE__ */ React.createElement(React.Fragment, null, mandatoryFields.map(renderField), /* @__PURE__ */ React.createElement(StyledButton, { bsStyle: "info", onClick: () => setDisplayOptionalFields(!displayOptionalFields) }, /* @__PURE__ */ React.createElement(StyledIcon, { name: displayOptionalFields ? "keyboard_arrow_down" : "chevron_right" }), displayOptionalFields ? "Hide" : "Show", " optional fields"), displayOptionalFields && optionalFields.map(renderField));
};
export default InputConfigurationForm;
